import { render, staticRenderFns } from "./ShowDishCard.vue?vue&type=template&id=372c7470&scoped=true&"
import script from "./ShowDishCard.vue?vue&type=script&lang=js&"
export * from "./ShowDishCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "372c7470",
  null
  
)

export default component.exports